/* eslint-disable multiline-ternary */
import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import Header from 'src/components/header/Header';
import { Card, ConditionalComponent, ConfirmModal, InfiniteScroll, Loader } from 'src/components/common';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import '../dashboard/dashboard.scss';
import cx from './ideahub.module.scss';
import IdeaHubBanner from 'src/components/ideahub-simple/IdeabHubBanner/IdeahubBanner';
import MyIdeaListCard from 'src/components/ideahub-simple/my-ideas-list/MyIdeaListCard';
import { Form, Formik } from 'formik';
import editDetailsValidationSchema from './editDetails.validationSchema';
import { Industries } from 'src/constants/user.constants';
import { createIdea, updateIdea } from 'src/store/chat/chat.slice';
import { enumToJson } from 'src/utils';
import InputField2 from 'src/components/common/formFields/input-field2/InputField2';
import { componentSizeVariantsEnum } from 'src/constants';
import SelectField from 'src/components/common/formFields/selectField/SelectField';
import TextAreaField2 from 'src/components/common/formFields/text-area-2/TextAreaField2';
import GradientButton from 'src/components/common/formFields/gradient-button/GradientButton';
import { TGetIdeaRequest } from 'src/services/apiEndpoint.types.ts';
import { getIdea } from 'src/store/ideaHub/ideaHub.slice';
export type TEditIdeaDetailsFormValues = {
  ideaId?: string;
  ownerId?: string;
  title?: string;
  domain?: string;
  description?: string;
  competitors?: string;
  identifiedProblem?: string;
  majorRevenueStream?: string;
  solutionEffectiveness?: string;
  targetAudience?: string;
  uniqueValueProposition?: string;
};

const initialValue: TEditIdeaDetailsFormValues = {
  title: '',
  domain: '',
  description: '',
  competitors: '',
  identifiedProblem: '',
  majorRevenueStream: '',
  solutionEffectiveness: '',
  targetAudience: '',
  uniqueValueProposition: ''
};
const IdeaHub = () => {
  // Hooks
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const { paramValue } = useUrlParamValue();
  const { getIdentities } = useGetIdentity();
  const isAuthorized: boolean = useAppSelector<boolean>((store: any) => store.auth.isAuthorized);
  const { ideaLoader } = useAppSelector(
    (store: any) => store.chat
  );
  const { loading } = useAppSelector(
    (store) => store.common
  );

  // state
  const [show, setShow] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<TEditIdeaDetailsFormValues>(initialValue);
  const { authenticatedId } = getIdentities();
  const ideaId = paramValue({ paramName: 'id' }) as unknown as string;
  console.log(ideaId, 'ideaiddata')
  const industriesOptions = enumToJson({
    enumData: Industries
  });
  const [viewIdea, setViewIdea] = useState<any>(null);

  // constant 
  const handleSubmit = (values: TEditIdeaDetailsFormValues) => {
    let payload: TEditIdeaDetailsFormValues = { ...values, ownerId: authenticatedId };
    if (ideaId) {
      payload = { ...payload, ideaId };

      dispatch(updateIdea(payload)).then((response: any) => {
        if (response?.data?.idea?.id) {
          navigate(`/idea-detail?id=${response?.data?.idea?.id}`)
        }
      })
    } else {
      dispatch(createIdea(payload)).then((response: any) => {
        if (response?.data?.idea?.id) {
          navigate(`/idea-detail?id=${response?.data?.idea?.id}`)
        }
      })
    }
  };
  const fetchIdea = useCallback(() => {
    if (!authenticatedId || !ideaId || loading) return;

    const payload: TGetIdeaRequest = {
      ideaId,
      userId: authenticatedId
    };
    dispatch(getIdea(payload)).then((response: any) => {
      console.log(response, 'responsedata');
      
      setViewIdea(response?.data);
    })
  }, [authenticatedId, ideaId, dispatch]);
  console.log(viewIdea, 'viewIdea');
  
  useEffect(() => {
    if (viewIdea?.idea?.id && viewIdea.idea.id === ideaId) {
      const newInitialValues = {
        title: viewIdea?.idea?.title || '',
        domain: viewIdea?.idea?.domain || '',
        description: viewIdea?.idea?.description || '',
        competitors: viewIdea?.idea?.competitors || '',
        identifiedProblem: viewIdea?.idea?.identifiedProblem || '',
        majorRevenueStream: viewIdea?.idea?.majorRevenueStream || '',
        solutionEffectiveness: viewIdea?.idea?.solutionEffectiveness || '',
        targetAudience: viewIdea?.idea?.targetAudience || '',
        uniqueValueProposition: viewIdea?.idea?.uniqueValueProposition || ''
      };

      if (JSON.stringify(initialValues) !== JSON.stringify(newInitialValues)) {
        setInitialValues(newInitialValues);
      }
    }
  }, [viewIdea?.idea?.id, ideaId]);
  useEffect(() => {
    fetchIdea();
  }, [ideaId, authenticatedId, fetchIdea]);
  function handleNavigate() {
    navigate('/login?prev=/discover')
  }
  return (
    <>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
      <div
        className="dashboard"
      >
        <Header />
        <div className="dashboard__body dashboard__newBody">
          <Card className="dashboard__body__feed">
            <IdeaHubBanner />
            <div className="dashboard__body__feed__items">
                <Formik
                  initialValues={initialValues}
                  validationSchema={editDetailsValidationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize>
                  {({ errors, setFieldValue, touched, values, handleSubmit }) => {
                    console.log(values, errors, ' touched');

                    return (
                      <Form noValidate className="create-edit-post-modal__content__form">
                        <div className={cx.formContainer}>
                          <h5 className={cx.heading}>Tell me about your idea</h5>
                          <InputField2
                            id="title"
                            style={{ marginTop: '-4px' }}
                            label="Title"
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                              } else {
                                setFieldValue('title', e.target.value);
                              }
                            }}
                            value={values.title}
                            placeholder="Title"
                            errorMessage={errors.title}
                            isTouched={touched.title}
                            required
                          />
                          <SelectField
                            label="Idea Domain"
                            placeholder="Select a specific domain your idea relates to"
                            variant={componentSizeVariantsEnum.SMALL}
                            selectedValue={values.domain || ''}
                            options={industriesOptions}
                            version='v2'
                            onSelection={({ value }) => {
                              if (!isAuthorized) {
                                setFieldValue('domain', '' as unknown as string);
                                setShow(true)
                                return
                              }
                              setFieldValue('domain', value as unknown as string);
                            }}
                            errorMessage={errors.domain}
                            isTouched={touched.domain}
                            required
                          ></SelectField>
                          <div className={cx.divider}></div>
                          <h5 className={cx.heading}>Problem and Solutions </h5>
                          <TextAreaField2
                            label="Identified Problem"
                            id="identifiedProblem"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="Clearly state and elaborate on the problem your idea aims to address"
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                              }
                              let updatedValue = e.target.value.replace(/\r/g, ''); // Normalize line breaks
                              if (updatedValue === "") {
                                console.log("yes");
                                updatedValue = " ";
                              }
                              setFieldValue('identifiedProblem', updatedValue);
                            }}
                            value={values.identifiedProblem}
                          />

                          {/* Solution Effectiveness */}
                          <TextAreaField2
                            label="Solution Effectiveness"
                            id="solutionEffectiveness"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="Explain how effective your proposed solution is in addressing the identified problem."
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                              }
                              const updatedValue = e.target.value;
                              setFieldValue('solutionEffectiveness', updatedValue);
                            }}
                            value={values.solutionEffectiveness}
                          />

                          {/* Unique Value Proposition */}
                          <TextAreaField2
                            label="Unique Value Proposition"
                            id="uniqueValueProposition"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="Describe the distinctive value your idea offers"
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                                return
                              }
                              const updatedValue = e.target.value;
                              setFieldValue('uniqueValueProposition', updatedValue);
                            }}
                            value={values.uniqueValueProposition}
                          />
                          <div className={cx.divider}></div>
                          <h5 className={cx.heading}>Business Model & Competitors</h5>
                          <TextAreaField2
                            label="Major Revenue Stream"
                            id="majorRevenueStream"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="Specify the primary source through which your business generates revenue"
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                                return
                              }
                              setFieldValue('majorRevenueStream', e.target.value);
                            }}
                            value={values.majorRevenueStream}
                          />

                          {/* Competitors */}
                          <TextAreaField2
                            label="Competitors"
                            id="competitors"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="List and analyze the key competitors in your idea."
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                                return
                              }
                              setFieldValue('competitors', e.target.value);
                            }}
                            value={values.competitors}
                          />
                          <TextAreaField2
                            label="Target Audience"
                            id="targetAudience"
                            variant={componentSizeVariantsEnum.SMALL}
                            placeholder="Describe the specific demographic or group your idea."
                            onChange={(e) => {
                              if (!isAuthorized) {
                                setShow(true)
                                return
                              }
                              setFieldValue('targetAudience', e.target.value);
                            }}
                            value={values.targetAudience}
                          />
                          <div className={cx.buttonContainer}>
                            <GradientButton loading={ideaLoader} onClick={handleSubmit} disabled={ideaLoader}>
                              {ideaId ? 'Update & Validate with AI' : 'Save & Validate with AI'}
                            </GradientButton>
                          </div>
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
            </div>
          </Card>
          <div className="dashboard__cards">
            <MyIdeaListCard />
          </div>
        </div>
        </div>
    </>
  );
};

export default IdeaHub;
